<div class="container d-flex flex-column">
  <div class="intro">
    <div class="intro-img-wrapper">
      <img src="assets/home/MATP-Site-Image-4.jpg" alt="Into" />
      <h1 class="overlay-text">
        The Medical Assistance
        <br />
        Transportation Program (MATP)
      </h1>
    </div>
  </div>
  <div class="about">
    <h2>About MATP</h2>
    <div class="content" [ngClass]="{ 'd-flex flex-row-reverse justify-content-between': !isMobile() }">
      <div class="about-img">
        <img src="assets/home/MATP-Site-Image-1.jpg" alt="About MATP" />
      </div>

      <div class="text" [ngClass]="{ 'd-flex flex-column': !isMobile() }" [style.display]="!isMobile() ? 'block' : 'contents'">
        <p>
          The Medical Assistance Transportation Program (MATP) in Pennsylvania helps people with Medicaid get free rides to medical appointments. The program is paid for by the
          Pennsylvania Department of Human Services. You can use MATP to get to doctors, dentists, mental health appointments, treatment centers, hospitals, pharmacies, and places
          that provide medical equipment.
        </p>
        <p>
          MATP will choose the least expensive way to get you there while still meeting your needs. This could be through public transit, a shared ride, or paying you back for
          using a private vehicle. MATP cannot be used for emergencies that need an ambulance, if you need equipment like a stretcher or ventilator, non-medical trips like
          shopping, or medical care that isn't covered by Medicaid.
        </p>
        <p class="bold">Reach out to your local county MATP agency for more information.</p>

        <button (click)="navigateToContactUs()" class="contact-us">Contact Us</button>
      </div>
    </div>
  </div>
  <div class="terms-conditions d-flex flex-column">
    <h2>Review our Terms and Conditions</h2>
    <p>
      This policy addresses the collection, security, access, and use of information that may be collected in your Mileage Reimbursement Account. This policy covers the following
      topics:
    </p>
    <div class="topics-details d-flex flex-column gap-10">
      <app-terms-condition-topic title="Information Collected">
        <div class="info-collected">
          <p>We collect the information below:</p>
        </div>
        <ul>
          <li>Demographic, financial and medical information</li>
          <li>The name of domain; for example, "xcompany.com" if you use a private internet access account, or "yourschool.edu", if you are connecting from a university domain</li>
          <li>An IP address, a number automatically assigned to your computer when you are using the internet</li>
          <li>The type of browser and operating system used to access our site</li>
          <li>The internet address of the website if you linked directly to our site</li>
          <li>The links made to other websites through this site</li>
        </ul>
        <p class="mt-10">
          This information is collected to allow access to your account, display benefits information, for statistical analysis, and quality assurance. This information is not
          collected or used for commercial marketing purposes. Information is retained in accordance with existing laws and other Commonwealth policies.
        </p>
      </app-terms-condition-topic>

      <app-terms-condition-topic title="Access and Disclosure">
        <p>
          Any personally identifiable information (PII) or Protected Health Information (PHI) you enter in a user profile will be open and available to you for review and updates.
          Generally, the Department uses information to provide benefits and services. There are some exceptions. For more information, see Pennsylvania’s Privacy Policy.
        </p>
      </app-terms-condition-topic>

      <app-terms-condition-topic title="Security">
        <p>
          The Commonwealth has taken steps to safeguard the submission of information by implementing detailed technology and security policies. For more information, see
          Pennsylvania’s Security Policy.
        </p>
        <p>
          You will have the opportunity to enter confidential information to access your current benefit information. You should not give your confidential information to anyone.
          To help protect your information, you should exit the Mileage Reimbursement Application when you are finished viewing your account.
        </p>
      </app-terms-condition-topic>

      <app-terms-condition-topic title="Information Disclaimer">
        <p>
          Information provided on the Mileage Reimbursement Application is intended to allow individuals access to their private and personal information. While all attempts are
          made to provide accurate, current and reliable information we recognize the possibility of human and/or mechanical error. Therefore, the Department of Human Services
          denies any warranty of the accuracy, reliability or timeliness of any information published by this system and shall not be held liable for any losses caused by reliance
          upon the accuracy, reliability or timeliness of such information. Any person who relies upon such information obtained from this system does so at his or her own risk.
        </p>
      </app-terms-condition-topic>

      <app-terms-condition-topic title="Penalty for Misuse">
        <p>
          Misuse of the Mileage Reimbursement Application, including inappropriate access to another’s account, knowingly giving false information, or any other fraudulent use can
          result in penalties under Pennsylvania laws.
        </p>
      </app-terms-condition-topic>
    </div>
  </div>
  <div class="external d-flex flex-row">
    <div class="compass">
      <h2>COMPASS</h2>
      <p>Not enrolled in Medical Assistance yet? Apply through COMPASS or contact your local County Assistance Office.</p>
      <a href="https://www.compass.dhs.pa.gov" target="_blank">Enroll Now at COMPASS</a>
    </div>
    <div class="fmr">
      <h2>Find My Ride</h2>
      <p>Not enrolled in MATP Services? Apply through Find My Ride or contact your local County Assistance Office.</p>
      <a href="https://apply.findmyride.penndot.pa.gov/tes-web/public/home#header" target="_blank">Apply at FMR</a>
    </div>
  </div>
  <div class="fraud-warning">
    <h2 class="mt--10">Fraud Warning and Prevention</h2>
    <div class="fraud-img">
      <img src="assets/home/MATP-Site-Image-2.jpg" alt="Fraud Warning" />
    </div>
    <p>
      You can help protect public assistance resources for those who need it by reporting suspected fraud or abuse of public assistance programs. The Department of Human Services
      works in collaboration with the
      <a href="https://www.pa.gov/agencies/osig" target="_blank">Office of State Inspector General</a>
      to identify and investigate potential fraud and abuse of public assistance programs so they’re protected for those who need them most.
    </p>
    <p>
      Anyone who suspects potential fraud or abuse of programs like Medicaid, the Supplemental Nutrition Assistance Program (SNAP), cash assistance, or other benefits programs
      should call the Fraud Tip Hotline at 1-844-DHS-TIPS (1-844-347-8477).
    </p>
    <p>Anyone who suspects transportation provider fraud, should contact the appropriate County MATP Administrator.</p>
  </div>
  <div class="guides d-flex flex-row">
    <div class="user-guides">
      <h2>User Guide</h2>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud
        exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
      </p>
    </div>
    <div class="downloads">
      <h2>Downloads</h2>
      <div class="links d-flex flex-column">
        <a href="javascript:void()">Link of Guide Number One</a>
        <a href="javascript:void()">Link of Guide Number Two</a>
        <a href="javascript:void()">Link of Guide Number Three</a>
        <a href="javascript:void()">Link of Guide Number Four</a>
        <a href="javascript:void()">Link of Guide Number Five</a>
      </div>
    </div>
  </div>

  <div class="process d-flex flex-column">
    <h2>What is the process to apply for transportation assistance?</h2>
    @if (isMobile()) {
      <img id="app-steps" src="assets/flow-vert.svg" alt="Applications Steps" />
    } @else {
      <img id="app-steps" src="assets/flow-horz.svg" alt="Applications Steps" />
    }
  </div>

  <div class="faq d-flex flex-column align-items-center">
    <h2>Frequently Asked Question</h2>
    <div class="questions">
      <mat-accordion displayMode="flat" class="faq-accordion">
        @for (faq of faqs; track faq.question) {
          <mat-expansion-panel hideToggle>
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{ faq.question }}
              </mat-panel-title>
              <mat-icon>add</mat-icon>
            </mat-expansion-panel-header>
            <p>{{ faq.answer }}</p>
          </mat-expansion-panel>
        }
      </mat-accordion>
    </div>
  </div>
</div>
